module.exports = __webpack_public_path__ + "img/20230803083849561k28.733f5a5d.jpg";